import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Home from './pages/Home.vue';
import About from './pages/About.vue';
import Project from './pages/Project.vue';
import Contact from './pages/Contact.vue';
import NotFound from './pages/NotFound.vue';



const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/about",
            name: "about",
            component: About
        },
        {
            path: "/projects",
            name: "project",
            component: Project
        },
        {
            path: "/contact",
            name: "contact",
            component: Contact
        },
        {
            path: "/*",
            name: "not-found",
            component: NotFound
        },
        { path: '/page-not-found',
        component: NotFound //Vue component
        },
        { path: '*', redirect: '/not-found' }
        
    ]
});
// NAVIGATION GUARDS 
router.beforeEach((to,from,next) => {
    document.title = ` ${ process.env.VUE_APP_TITLE } - ${ to.name } `
    next()
});

export default router;